import ComicCard from '@/components/base/ComicCard';
import { getPopularComics } from '@/mocks/comics';

export default function PopularRanking() {
  const popular = getPopularComics(8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              人气排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受欢迎的韩漫，大家都在看</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {popular.map((comic, index) => (
            <ComicCard key={comic.id} comic={comic} size="medium" showRank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}